import _ from './utility';
import modal from './modal'

/*
Notification service has some limit on email fields: subject: 70 ; message(body): 200
Also, there should be no line breaks (\n) in email fields but html tags are ok
*/

const email = {
	
	loadSendMsg: function() {
		if (typeof sendMsgInit == 'undefined') {
			var sendMsgJs = document.createElement('script');
			sendMsgJs.onload = function() {
				if (_.isCOE()) {
					var coeTitle = 'Take a look at the ' + document.querySelector('h1').innerText.replace(/\s\s+/g,' ').trim() + ' Center of Excellence on Medscape';
					sendMsgInit({
						subject: coeTitle
					});					
				} else {
					sendMsgInit();
				}
			};
			document.body.appendChild(sendMsgJs);
			sendMsgJs.src = 'https://img.' + getDomain() + 'medscapestatic.com/medscape-core/common/js/send-msg/send-msg.js';
		} else {
			sendMsgInit();
		}
	},
	
	loadFeedback: function() {
		if (typeof sendFeedbackInit == 'undefined') {
			var sendMsgJs = document.createElement('script');
			sendMsgJs.onload = function() {		
				sendFeedbackInit(null, {'header': 'Help us make Medscape the best clinical resource possible. Please use this form to submit your questions or comments on how to make this resource center more useful to clinicians.', 'footer': 'Please <b><u>do not</u></b> use this form to submit personal or patient medical information or to report adverse drug events. You are encouraged to report adverse drug event information to the FDA.'});
			};
			document.body.appendChild(sendMsgJs);
			sendMsgJs.src = 'https://img.' + getDomain() + 'medscapestatic.com/medscape-core/common/js/send-msg/send-msg.js';
		} else {
			sendFeedbackInit(null, {'header': 'Help us make Medscape the best clinical resource possible. Please use this form to submit your questions or comments on how to make this resource center more useful to clinicians.', 'footer': 'Please <b><u>do not</u></b> use this form to submit personal or patient medical information or to report adverse drug events. You are encouraged to report adverse drug event information to the FDA.'});
		}
	}

};

function init() {
	if ($('section.disclaimer').text().trim() != '') {
		$('section.disclaimer').append('<div class="feedback"><button id="feedback-btn">Feedback</button></div>');
	}
    $('#email').click(function() {
		email.loadSendMsg();
	});
	if($(".coe-v2").length > 0) {
		$('.email').click(function() {
			email.loadSendMsg();
		});		
	}
    $('#feedback-btn').click(function() {
		email.loadFeedback();
	});
}

export default _.catch(init);